import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {AdalService} from 'adal-angular4';

@Component({
  selector: 'not-available',
  template: '<p>Funkcja niedostępna w aplikacji.</p>',
  styleUrls: []
})
export class NotAvailableComponent implements OnInit {
  public routeLinks: any[];

  public get showTabs() {
    return this.adal.userInfo.authenticated;
  }

  constructor(private router: Router, public adal: AdalService, private route: ActivatedRoute) {
    this.routeLinks = [
      { label: 'Section1', link: 'sec1', index: 0 },
      { label: 'Section2', link: 'sec2', index: 1 },
      { label: 'Section3', link: 'sec3', index: 2 },
      { label: 'Section4', link: 'sec4', index: 3 },
      { label: 'Section5', link: 'sec5', index: 4 },
    ];
  }

  ngOnInit() {
  }
}
